import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../api/client';
import { useApi } from '../api/useApi';

const W: Record<string, string> = { H: 'w-h', M: 'w-m', L: 'w-l', '—': 'w-tbd' };

export default function ScoringMatrix() {
  const navigate = useNavigate();
  const [exported, setExported] = useState(false);
  const { data: scoring, loading, error } = useApi<any>(() => API.scoring());

  if (loading) return <div className="phil-loading">Loading…</div>;
  if (error || !scoring) return <div className="phil-error">Unable to load scoring matrix. {error}</div>;
  const rows = scoring.rows ?? [];

  return (
    <>
      <div className="breadcrumb">
        <a onClick={() => navigate('/feedback-priorities')}>Feedback &amp; Priorities</a>
        <span className="bc-sep">›</span>
        <span>Scoring Matrix</span>
      </div>

      <div className="page-header">

        <h1>{scoring.cycle ? `${scoring.cycle} ` : ''}Priority Mapping — All FIs</h1>
        <p className="subtitle">H = ×3, M = ×2 · Buckets ranked by weighted sum across FIs.</p>
      </div>

      <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center' }}>
        <button
          className={`btn btn-sm ${exported ? 'btn-outline' : 'btn-primary'}`}
          onClick={async () => { await API.exportPriorityReport(scoring.cycle); setExported(true); }}
        >
          {exported ? '✓ Exported' : 'Export Priorities Report'}
        </button>
        <div style={{ fontSize: 12, color: '#6b7280', marginLeft: 'auto' }}>
          {rows.length} priority buckets · ranked by weighted score
        </div>
      </div>

      <div className="card" style={{ overflow: 'auto' }}>
        <table style={{ minWidth: 780 }}>
          <thead>
            <tr>
              <th>Priority</th>
              <th>Type</th>
              <th style={{ textAlign: 'center' }}>H</th>
              <th style={{ textAlign: 'center' }}>M</th>
              <th style={{ textAlign: 'center' }}>FIs</th>
              <th style={{ background: '#dbeafe', color: '#1d4ed8', textAlign: 'center' }}>Weighted</th>
              <th style={{ background: '#dbeafe', color: '#1d4ed8', textAlign: 'center' }}>Rank</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row: any) => (
              <tr key={row.priority}>
                <td className="font-semibold">{row.priority}</td>
                <td style={{ fontSize: 12, color: '#6b7280' }}>{row.type}</td>
                <td style={{ textAlign: 'center' }}><span className="w-h">{row.h}</span></td>
                <td style={{ textAlign: 'center' }}><span className="w-m">{row.m}</span></td>
                <td style={{ textAlign: 'center', color: '#4b5563' }}>{row.fis}</td>
                <td style={{ textAlign: 'center', fontWeight: 700, fontSize: 15, color: '#0f172a' }}>{row.score}</td>
                <td style={{ textAlign: 'center' }}>
                  <span style={{
                    fontSize: 11, fontWeight: 700,
                    background: row.rank <= 3 ? '#dbeafe' : '#f8fafc',
                    color: row.rank <= 3 ? '#1d4ed8' : '#6b7280',
                    padding: '2px 8px', borderRadius: 100
                  }}>
                    #{row.rank}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 16, display: 'flex', gap: 24 }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <span className="w-h">H</span>
          <span style={{ fontSize: 12, color: '#4b5563' }}>Explicitly called out (×3)</span>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <span className="w-m">M</span>
          <span style={{ fontSize: 12, color: '#4b5563' }}>Called out when asked (×2)</span>
        </div>
      </div>

      <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
        <button className="btn btn-outline btn-sm" onClick={() => navigate('/feedback-priorities')}>← FI List</button>
        <button className="btn btn-outline btn-sm" onClick={() => navigate('/dashboard')}>Back to Dashboard</button>
      </div>
    </>
  );
}
